"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplicaCustomReportResponseSchema = exports.ReplicaCustomReportQuerySchema = exports.UpdateReplicaCustomReportsBodySchema = exports.UpdateCustomReportSchema = exports.ReplicaCustomReportSchema = exports.castToRank = exports.ReplicaKeywordRank = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const utils_1 = require("../../../utils");
const apple_proxy_web_1 = require("../../apple-proxy-web");
const common_1 = require("./common");
var ReplicaKeywordRank;
(function (ReplicaKeywordRank) {
    ReplicaKeywordRank["ONE"] = "ONE";
    ReplicaKeywordRank["TWO"] = "TWO";
    ReplicaKeywordRank["THREE"] = "THREE";
    ReplicaKeywordRank["FOUR"] = "FOUR";
    ReplicaKeywordRank["FIVE"] = "FIVE";
    ReplicaKeywordRank["GREATER_THAN_FIVE"] = "GREATER_THAN_FIVE";
    ReplicaKeywordRank["UNKNOWN"] = "--";
})(ReplicaKeywordRank = exports.ReplicaKeywordRank || (exports.ReplicaKeywordRank = {}));
exports.castToRank = (0, utils_1.castToEnum)(ReplicaKeywordRank);
exports.ReplicaCustomReportSchema = (0, core_1.StrictObject)({
    teamId: typebox_1.Type.Integer(),
    adamRef: ruby_1.AppleProxyRefSchema,
    appName: typebox_1.Type.String(),
    country: apple_proxy_web_1.AppleProxyCountryOrRegionSchema,
    searchTerm: typebox_1.Type.String(),
    period: typebox_1.Type.Integer(),
    lowImpressionShare: typebox_1.Type.Number(),
    highImpressionShare: typebox_1.Type.Number(),
    rank: (0, core_1.StringUnion)(Object.values(ReplicaKeywordRank)),
    searchPopularity: typebox_1.Type.Integer(),
    reportRef: typebox_1.Type.Integer(),
    orgRef: typebox_1.Type.Integer(),
});
exports.UpdateCustomReportSchema = typebox_1.Type.Object({
    lowImpressionShare: typebox_1.Type.Number(),
    highImpressionShare: typebox_1.Type.Number(),
    rank: (0, core_1.StringUnion)(Object.values(ReplicaKeywordRank)),
    searchPopularity: typebox_1.Type.Integer(),
    searchTerm: typebox_1.Type.String(),
});
exports.UpdateReplicaCustomReportsBodySchema = typebox_1.Type.Object({
    team: typebox_1.Type.Integer(),
    adamRef: ruby_1.AppleProxyRefSchema,
    reports: typebox_1.Type.Array(exports.UpdateCustomReportSchema),
});
exports.ReplicaCustomReportQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...common_1.ReplicaCustomReportMetadataQueryFields,
    searchTerm: typebox_1.Type.Optional(typebox_1.Type.String()),
});
/**
 * Responses
 */
exports.ReplicaCustomReportResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ReplicaCustomReportSchema);
